import { Component, OnInit, ChangeDetectorRef, AfterViewChecked } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import { tanquesModuleName, tanquesStorage } from "../shared/data.service";
import { Tanque } from "../shared/tanque.model";
import {editRoute, newRoute, configuracaoModuleName} from "../../../shared/services/data.service";
import { TanqueNavigationService } from "../shared/tanque-navigation.service";
import { TanqueApiService } from "../shared/tanque-api.service";
import { UtilService } from "../../../shared/services/util.service";
import { TanqueService } from "../shared/tanque.service";
import {abastecimentosRoute, abastecimentosModuleName} from "../../shared/data.service";
import { AbastecimentoService } from "../../shared/abastecimento.service";
import { NumberValidator } from "../../../shared/validators/number.validation";
import { Combustivel } from "../../combustiveis/shared/combustivel.model";
import { Local } from "../../locais/shared/local.model";
import { CombustivelApiService } from "../../combustiveis/shared/combustivel-api.service";
import { LocalApiService } from "../../locais/shared/local-api.service";
import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";
import { CombustivelNavigationService } from "../../combustiveis/shared/combustivel-navigation.service";
import { LocalNavigationService } from "../../locais/shared/local-navigation.service";
import { combustiveisQuery, combustiveisStorage } from "../../combustiveis/shared/data.service";
import { locaisQuery, locaisStorage } from "../../locais/shared/data.service";
import { LocalService } from "../../locais/shared/local.service";
import {NumberMaxMinValueValidator} from "../../../shared/validators/number-max-min-value.validation";

@Component({
    template: require('./tanque-form.component.html'),
    styles: [require('./tanque-form.component.css')]
})
export class TanqueFormComponent implements OnInit, AfterViewChecked {
    abastecimentosRoute: string = abastecimentosRoute;
    tanquesModule: any = tanquesModuleName;
    formObject: any = new Tanque();
    combustivelObject: any = new Combustivel();
    localObject: any = new Local();
    actionTitle: string;
    submitted: boolean = false;
    btnSaveDisabled: boolean = false;
    module: any = abastecimentosModuleName;
    configuracaoModule: any = configuracaoModuleName;

    combustivelSelectId: string = 'combustivelSelect';
    combustivelQuery: any;
    localSelectId: string = 'localSelect';
    localQuery: any;

    form: FormGroup;
    ativo = new FormControl('');
    identificacao = new FormControl('', Validators.required);
    numeroPatrimonio = new FormControl('', Validators.required);
    capacidade = new FormControl('', Validators.compose([Validators.required, NumberValidator.numberFormat]));
    local = new FormControl('', Validators.required);
    combustivel = new FormControl('', Validators.required);
    statusAmarelo = new FormControl('', Validators.compose([Validators.required, NumberMaxMinValueValidator.numberMaxMin(0, 100)]));
    statusVermelho = new FormControl('', Validators.compose([Validators.required, NumberMaxMinValueValidator.numberMaxMin(0, 100)]));

    private tipoLocalInterno: number;
    private returnToOtherForm: boolean = false;
    private otherForm: string;
    private responseTanque: any;

    constructor(
        private _route: ActivatedRoute,
        private _tanqueNavigationService: TanqueNavigationService,
        private _tanqueApiService: TanqueApiService,
        private _tanqueService: TanqueService,
        private _utilService: UtilService,
        private _abastecimentoService: AbastecimentoService,
        private _combustivelApiService: CombustivelApiService,
        private _localApiService: LocalApiService,
        private _autocompleteService: AutoCompleteService,
        private _combustivelNavigationService: CombustivelNavigationService,
        private _localNavigationService: LocalNavigationService,
        private _localService: LocalService,

        private _fb: FormBuilder,
        private _cdRef:ChangeDetectorRef
    ) {
        this.form = _fb.group({
            ativo: this.ativo,
            identificacao: this.identificacao,
            numeroPatrimonio: this.numeroPatrimonio,
            capacidade: this.capacidade,
            local: this.local,
            combustivel: this.combustivel,
            statusVermelho: this.statusVermelho,
            statusAmarelo: this.statusAmarelo
        });
    }

    ngOnInit() {
        this.combustivelQuery = this._utilService.cloneObject(combustiveisQuery);
        this.localQuery = this._utilService.cloneObject(locaisQuery);
        let tipoLocalInterno: any = this._localService.getTipoInterno();
        this.tipoLocalInterno = tipoLocalInterno.Key;
        this.localQuery.where.tipo = this.tipoLocalInterno;

        this.isNewAutoComplete();
    }

    ngAfterViewChecked() {
        this._cdRef.detectChanges();
    }

    clickGoToList() {
        this.goToList();
    }

    clickGoToSettings() {
        this._abastecimentoService.goToSetting();
    }

    clickCancel() {
        this.toLeaveHere();
    }

    onSubmit(evt: any) {
        this.submitted = true;
        if(evt.valid) {
            this.btnSaveDisabled = true;
            let object:Tanque = this._utilService.cloneObject(this.formObject);

            if (this.combustivelObject.id) {
                object.combustivelId = this.combustivelObject.id;
            } else  {
                this.btnSaveDisabled = false;
                return false;
            }

            if (this.localObject.id) {
                object.localId = this.localObject.id;
            } else {
                this.btnSaveDisabled = false;
                return false;
            }

            if (this.formObject.id) {
                this.onEditTanque(object);
            } else {
                this.onAddTanque(object);
            }
        }
    }

    getCombustivelObject(object: any) {
        if(object.novo) {
            let thisFormObject: any = this.formObject;
            thisFormObject.combustivel = this.combustivelObject;
            thisFormObject.local = this.localObject;

            this._tanqueService.setSessionStorage(thisFormObject);

            let toOtherFormObject: any = {
                combustivel: object.text,
                form: tanquesStorage
            };

            this._autocompleteService.setSessionStorage(toOtherFormObject, combustiveisStorage);
            this._combustivelNavigationService.goToNew();
        } else {
            this.combustivelObject = object;
            this._utilService.setSelectOnFormControl(this.form, 'combustivel', object);
        }
    }

    getLocalObject(object: any) {
        if(object.novo) {
            let thisFormObject: any = this.formObject;
            thisFormObject.combustivel = this.combustivelObject;
            thisFormObject.local = this.localObject;

            this._tanqueService.setSessionStorage(thisFormObject);

            let toOtherFormObject: any = {
                nome: object.text,
                tipo: this.tipoLocalInterno,
                form: tanquesStorage
            };

            this._autocompleteService.setSessionStorage(toOtherFormObject, locaisStorage);
            this._localNavigationService.goToNew();
        } else {
            this.localObject = object;
            this._utilService.setSelectOnFormControl(this.form, 'local', object);
        }
    }

    private onAddTanque(object: Tanque) {
        this._tanqueApiService.onPost(object, this.onDone);
    }

    private onEditTanque(object: Tanque) {
        this._tanqueApiService.onPut(object, this.onDone);
    }

    private onDone = (function (Response: any) {
        if (!Response.error)  {
            Response.combustivel = this.combustivelObject;
            this.responseTanque = Response;
            if (this.formObject.id) {
                this._utilService.swalMessageEditSuccess();
            } else {
                this._utilService.swalMessageAddSuccess();
            }

            this.toLeaveHere();

        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private getObject(id: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.formObject = Response;
                this.setModelToForm();
            } else {
                this._utilService.swalMessageWarningCustom('Nenhum tanque encontrado com este id.');
                this.toLeaveHere();
            }
        }.bind(this));

        this._tanqueApiService.onGetById(id, onDone);
    }

    private isNewAutoComplete() {
        var newAutoComplete: any = this._autocompleteService.getSessionStorage(tanquesStorage);
        if (newAutoComplete) {
            this.returnToOtherForm = true;
            this.otherForm = newAutoComplete.form;
            this.formObject.identificacao = newAutoComplete.identificacao;

            this.setActionTitle(this.formObject.id);
        } else {
            //retornando de um cadastro
            this.testSession();
        }
    }

    private testSession() {
        let id: number;
        let session: any = this._tanqueService.getSessionStorage();
        this._tanqueService.clearSessionStorage();

        if (session) {
            this.formObject = session;
            id = session.id;
            this.setModelToForm();
        } else {
            id = +this._route.snapshot.params['id'];
            if (id) {
                this.setEditNormal(id);
            } else {
                this.setNewNormal();
            }
        }

        this.setActionTitle(id);
    }

    private setModelToForm() {
        if (this.formObject.combustivel) {
            this.combustivelObject = this.formObject.combustivel;
            delete this.formObject['combustivel'];

            let text = this._autocompleteService.getTextSelect2(this.combustivelObject, 'combustivel');
            let selectObject:any = {text: text, id: this.combustivelObject.id};

            this._autocompleteService.createOptionOnSelect2(this.combustivelSelectId, selectObject);
            this._autocompleteService.setValueOnSelect2(selectObject.id, this.combustivelSelectId);
            this._utilService.setSelectOnFormControl(this.form, 'combustivel', this.combustivelObject);
        }

        if (this.formObject.local) {
            this.localObject = this.formObject.local;
            delete this.formObject['local'];

            let text = this._autocompleteService.getTextSelect2(this.localObject, 'nome');
            let selectObject: any = {text: text, id: this.localObject.id};

            this._autocompleteService.createOptionOnSelect2(this.localSelectId, selectObject);
            this._autocompleteService.setValueOnSelect2(selectObject.id, this.localSelectId);
            this._utilService.setSelectOnFormControl(this.form, 'local', this.localObject);
        }
    }

    private toLeaveHere() {
        if (this.returnToOtherForm) {
            this._tanqueService.returnToOtherForm(this.otherForm, this.responseTanque);
        } else {
            this.goToList();
        }
    }

    private goToList() {
        this._tanqueNavigationService.goToList();
    }

    private setActionTitle(id: number) {
        if (id) {
            this.actionTitle = editRoute;
        } else {
            this.actionTitle = newRoute;
        }
    }

    private setEditNormal(id: number) {
        this.getObject(id);
    }

    private setNewNormal() {

    }

    private setEditSession() {
        //qndo retornou para continuar a edição
    }

    private setNewSession() {
        //qndo retornou para continuar o cadastro
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/tanques/tanque-form/tanque-form.component.ts
 **/